module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('big', [_c('big', [_c('b', [_vm._v("W")])])], 1), _vm._v("hy are most fly fishing guides 400 pages? It just doesn't make sense. Considering that there is no substitute for experience, the guiding principle of this book is to provide the essential information needed for fly fishing. The rest you will pick up later—from your own experiences, from other anglers, fly shops, magazines, web sites, fly-casting clinics, flytying demonstrations, and other sources. Another important point—this book doesn't mention any of the expensive, topof-the-line fishing gear. Instead, it steers readers to quality equipment that can be bought on a shoestring budget. The complete outfit for a fly fisherman or fisherwoman today could run $2,000 or more; this book shows you how to get started with just a few dollars.")], 1), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let's begin with a word about the sport of fly fishing and why Connecticut is the ideal place to embark on your journey. First, the dirty little secret: In order to catch native trout, an angler must travel by float plane to a stream north of Lac Saint-Jean, Quebec. Lac Saint-Jean, about a hundred miles north of Quebec city, marks the northernmost reach of the provincial government's stocking programs. However, it is not uncommon for serious anglers to spend thousands of dollars on seven-day fishing trips to northern Quebec—700 miles north of Hartford, Connecticut. But the average weekend angler…?")]), _vm._v(" "), _vm._m(1)]), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5)]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ch-img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/intro1.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_vm._v("An Angler is a person who fishes using a fishing rod and a line. Dame Juliana Berners is a famous angler from the 15"), _c('sup', [_vm._v("th")]), _vm._v(" century. She used a fly fishing rig.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("So what about the quality of fishing below Lac Saint-Jean? Surely there's plenty ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("of fish and pristine spots to be found in New England. Well, it depends entirely on the sophistication of a state's hatchery and stocking programs. Happily for Connecticut residents, the state's DEP Inland Fisheries Division enjoys an enviable reputation, raising about 800,000 catchable-sized trout annually and stocking almost 300 pristine rivers, streams, lakes, and ponds. Trout are Connecticut's most sought after game fish, generating two million fishing outings each year.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("While fly fishing in Connecticut, you will enjoy some of the most beautiful scenery on earth—the flora and fauna of a king's private game preserve. You'll see bear, deer, beaver, opossum, skunks, rabbit, ducks, geese—and, yes my fellow angler, you'll see plenty of trout. Count on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the while, the waters of your favorite stream will massage your body until you are as relaxed as a tourist in New Brunswick. While fly fishing, you'll be pampered and soothed for the nominal cost of a Connecticut fishing license.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To some extent, you will learn about ichthyology, entomology, hydrology, hydrography, meteorology, and biology. Don't be intimidated. Your education will be slow and effortless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You'll have the great satisfaction of catching fish in a very ingenious manner. Fly fishing has been called the most elegant way to catch fish and that sums it up magnificently. Join your forebears—Winslow Homer, Clark Gable, Ernest Hemingway, Buffalo Bill, Annie Oakley, Zane Gray, Grover Cleveland, Teddy Roosevelt, Calvin Coolidge, Dwight Eisenhower, Ted Turner, Tom Brokaw, Meg Whitman, and thousands of other famous and not so famous Americans— and learn the delights of fly fishing. There's no better place to learn than on one of Connecticut's wild and scenic trout streams.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As with all sports and pastimes, fly fishing has its own peculiar vocabulary. You'll find help in the sidebars, and a full glossary at the end of the book.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Any reference to fly shops or equipment manufacturers is not meant as an endorsement. I scoured the fly-fishing ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("world for the latest equipment and information—just as you must. If the name of a product, company, fly shop, fishing guide, or angler accommodation is mentioned, it is simply to get you started on your own search. I have received no compensation—financial or otherwise—from any equipment manufacturer, fishing outlet, guide service, lodge, hatchery, or anyone else connected with the sport of fly fishing.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A point of clarification: The state's fish and game department has operated under four titles over the past century and a half. From the Civil War until the 1920s, it was the State of Connecticut Fisheries Commission. During the Roaring Twenties, and for the next four decades, it was the State Board of Fish and Game. From 1972 to the mid-1990s, it operated as the Fisheries Division. Today it is called the Inland Fisheries Division. For simplicity's sake, the “fisheries commission” will be used until 1972, and “Inland Fisheries Division” from there on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lastly, I want to introduce a friend of mine, Sam Tippet. He'll share a few anecdotes and a wealth of tips on fly fishing. Sam knows all the tricks.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/sam.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "box-para"
  }, [_c('i', [_vm._v("Lefty Kreh, the great American fly fisherman, who served as a guide for the legendary Joe Brooks once said, “There's more B.S. in fly fishing than there is in a Kansas feedlot.” I aim to demystify the sport by offering a few simple pointers from my forty years of fly fishing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e2622c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/intro.vue
// module id = 72
// module chunks = 0